import { ChevronDown } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';

export default function TournamentSelector({ tournaments, selectedTournamentId, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedTournament = tournaments.find(t => t.tournament_id === selectedTournamentId);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (tournaments.length === 0) {
    // Don't show selector if there are no tournaments at all
    return null;
  }
  
  // Always show selector as clickable, even with 1 tournament

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-md bg-emerald-800 hover:bg-emerald-700 text-emerald-100 text-sm font-manrope transition-colors"
        data-testid="tournament-selector-button"
      >
        <span className="hidden sm:inline">
          {selectedTournament?.name || `${selectedTournament?.year || ''} Tournament`}
        </span>
        <span className="sm:hidden">Tournament</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-50 border border-gray-200">
          <div className="py-1">
            <div className="px-4 py-2 text-xs font-bebas text-gray-500 uppercase tracking-wider border-b">
              Select Tournament
            </div>
            {tournaments.map((tournament) => {
              const isSelected = tournament.tournament_id === selectedTournamentId;
              return (
                <button
                  key={tournament.tournament_id}
                  onClick={() => {
                    onSelect(tournament.tournament_id);
                    setIsOpen(false);
                  }}
                  data-testid={`tournament-option-${tournament.tournament_id}`}
                  className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors ${
                    isSelected ? 'bg-amber-50' : ''
                  }`}
                >
                  <div className="font-bebas text-lg text-emerald-900">
                    {tournament.name || `${tournament.year || 'Unknown'} Tournament`}
                  </div>
                  <div className="text-xs font-manrope text-gray-600">
                    Year: {tournament.year || 'N/A'} | Status: <span className="uppercase font-bold">{tournament.status}</span>
                    {isSelected && <span className="ml-2 text-amber-600">✓ Active</span>}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
